import { motion } from "framer-motion";
import { PenTool, Cog, Dices, ArrowUpRight } from "lucide-react";
import { useLang } from "../../lib/lang";
import { SERVICE_COLORS, waLink } from "../../lib/content";
import { SectionHead, EASE } from "./Reveal";

const ICONS = { figure: PenTool, part: Cog, design: Dices };

const ServiceCard = ({ s, i, ask }) => {
  const Icon = ICONS[s.key];
  const c = SERVICE_COLORS[s.key];
  return (
    <motion.a
      href={waLink(`${ask}: ${s.title}`)}
      target="_blank"
      rel="noreferrer"
      data-testid={`service-card-${s.key}`}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay: i * 0.12, ease: EASE }}
      whileHover={{ y: -8 }}
      style={{ "--c": c }}
      className="group relative flex flex-col justify-between min-h-[340px] lg:min-h-[420px] rounded-[26px] border border-white/10 bg-[#13182E] p-7 lg:p-9 overflow-hidden hover:border-[color:var(--c)] transition-colors duration-500"
    >
      <div className="absolute -right-16 -top-16 w-56 h-56 rounded-full opacity-25 blur-3xl transition-opacity duration-500 group-hover:opacity-60" style={{ background: c }} />
      <div className="relative flex items-start justify-between">
        <span className="grid place-items-center w-14 h-14 rounded-2xl" style={{ background: `${c}26`, border: `1px solid ${c}66` }}>
          <Icon className="w-7 h-7" style={{ color: c }} />
        </span>
        <span className="font-mono text-sm text-slate-400">0{i + 1}</span>
      </div>
      <div className="relative">
        <h3 className="font-display text-2xl lg:text-3xl text-white uppercase leading-none">{s.title}</h3>
        <p className="mt-4 text-slate-300 leading-relaxed">{s.desc}</p>
        <span className="mt-8 inline-flex items-center gap-2 text-sm font-semibold" style={{ color: c }}>
          {ask} <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </span>
      </div>
    </motion.a>
  );
};

export const Services = () => {
  const { t } = useLang();
  return (
    <section id="services" className="relative mx-auto max-w-[1400px] px-5 lg:px-10 py-24 lg:py-36">
      <SectionHead eyebrow={t.servicesEyebrow} title={t.servicesTitle} testid="services-title" />
      <div className="grid md:grid-cols-3 gap-5 lg:gap-6">
        {t.services.map((s, i) => <ServiceCard key={s.key} s={s} i={i} ask={t.serviceAsk} />)}
      </div>
    </section>
  );
};
